function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError('Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o)
        return;
    if (typeof o === 'string')
        return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor)
        n = o.constructor.name;
    if (n === 'Map' || n === 'Set')
        return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
        return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== 'undefined' && iter[Symbol.iterator] != null || iter['@@iterator'] != null)
        return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr))
        return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length)
        len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++)
        arr2[i] = arr[i];
    return arr2;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import Bar from './bar';
import FullScreen from './fullscreen';
import Danmaku from './danmaku';
import handleOption from './options';
import Timer from './timer';
import Controller from './controller';
import Events from './events';
import Setter from './set';
import Template from './template';
import utils from './utils';
import {
    getVideoTime,
    resetVideoTime
} from './video';
import tplVideo from '../template/video.art';
import tplResolution from '../template/set/resolution.art';
import {
    addHls,
    addFlv,
    initFlv,
    initHls
} from './MSE';
var index = 0;
var instances = [];
function getDate(dom) {
    var date = new Date();
    var hour = date.getHours();
    var minute = date.getMinutes();
    dom.innerHTML = (hour >= 10 ? hour : '0' + hour) + ':' + (minute >= 10 ? minute : '0' + minute);
}
var mfunsPlayer = function () {
    function mfunsPlayer(options) {
        var _this = this, _this$options, _this$options$danmaku;
        _classCallCheck(this, mfunsPlayer);
        _defineProperty(this, 'setPlayModer', void 0);
        this.options = handleOption(options);
        this.template = new Template(this.options);
        this.events = new Events();
        this.container = options.container;
        this.container.classList.add('mfunsPlayer', 'mfunsPlayer-paused');
        this.unableTimeupdate = false;
        this.isPlayEnd = false;
        this.isShowMenu = false;
        this.isSwitched = false;
        this.components = {};
        this.plugins = {};
        this.video = this.template.video;
        this.currentVideo = this.options.currentVideo;
        this.noticeList = {};
        this.bar = new Bar(this.template);
        this.timer = new Timer(this);
        this.autoSwitch = this.options.autoSwitch;
        this.listLoop = this.options.listLoop;
        this.fullScreen = new FullScreen(this);
        if (this.options.playCallback)
            this.playCallback = options.playCallback;
        if (this.options.pauseCallback)
            this.pauseCallback = options.pauseCallback;
        if (this.options.endedCallback)
            this.endedCallback = options.endedCallback;
        if (this.options.switchVideoCallback)
            this.switchVideoCallback = options.switchVideoCallback;
        this.clock = setInterval(function () {
            return getDate(_this.template.headTime);
        }, 1000);
        this.initVideo(this.video, this.options.video[this.currentVideo].type);
        this.initDeviceStatus();
        this.controller = new Controller(this);
        if ((_this$options = this.options) !== null && _this$options !== void 0 && (_this$options$danmaku = _this$options.danmaku) !== null && _this$options$danmaku !== void 0 && _this$options$danmaku.api || this.options.video[this.currentVideo].danmakuAddition) {
            var _this$options$danmaku2, _this$options$danmaku3, _this$options$danmaku4, _this$options$danmaku5, _this$options$danmaku6, _this$options$video$t;
            this.showDanmaku = this.options.danmaku.showDanmaku;
            this.danmakuOptions = {
                container: this.template.danmaku,
                opacity: (_this$options$danmaku2 = this.options.danmaku.opacity) !== null && _this$options$danmaku2 !== void 0 ? _this$options$danmaku2 : 1,
                fontScale: (_this$options$danmaku3 = this.options.danmaku.fontScale) !== null && _this$options$danmaku3 !== void 0 ? _this$options$danmaku3 : 1,
                speed: (_this$options$danmaku4 = this.options.danmaku.speed) !== null && _this$options$danmaku4 !== void 0 ? _this$options$danmaku4 : 1,
                limitArea: (_this$options$danmaku5 = this.options.danmaku.limitArea) !== null && _this$options$danmaku5 !== void 0 ? _this$options$danmaku5 : 4,
                callback: function callback(length, advDanData, isReload) {
                    console.log(length);
                    _this.danLength = length;
                    _this.danmakuLoaded = true;
                },
                error: function error(msg, isReload) {
                    console.error(msg);
                    _this.container.classList.remove('mfunsPlayer-load');
                },
                apiBackend: this.options.apiBackend,
                borderColor: '#FFFFFF',
                height: 22,
                time: function time() {
                    return _this.video.currentTime;
                },
                videoIndex: function videoIndex() {
                    return _this.currentVideo;
                },
                isShow: this.showDanmaku,
                danmakuCatch: (_this$options$danmaku6 = this.options.danmaku.danmakuCatch) !== null && _this$options$danmaku6 !== void 0 ? _this$options$danmaku6 : false,
                unlimited: false,
                api: {
                    address: this.options.danmaku.api,
                    id: this.options.video[this.options.currentVideo].danId,
                    danmakuAddition: this.options.video[this.options.currentVideo].danmakuAddition,
                    token: this.options.danmaku.token,
                    otherDanParams: (_this$options$video$t = this.options.video[this.options.currentVideo].otherDanParams) !== null && _this$options$video$t !== void 0 ? _this$options$video$t : ''
                },
                events: this.events
            };
            if (this.options.advancedDanmaku) {
                this.danmakuOptions.api.advDanApi = {
                    id: this.options.video[this.options.currentVideo].advDanId,
                    address: this.options.advancedDanmaku.api,
                    token: this.options.advancedDanmaku.token
                };
            }
            this.danmaku = new Danmaku(this.danmakuOptions, this);
        }
        this.set = new Setter(this);
        if (this.options.video[this.currentVideo].resolution) {
            var currentVideoOption = this.options.video[this.currentVideo];
            this.resolution = currentVideoOption.resolution.find(function (el) {
                return el.url === currentVideoOption.url;
            });
            this.template.resolution.innerHTML = this.resolution.name;
        }
        document.addEventListener('click', function () {
            _this.focus = false;
        }, true);
        this.container.addEventListener('click', function () {
            _this.focus = true;
        }, true);
        index++;
        instances.push(this);
        this.timer.enable('fps');
    }
    _createClass(mfunsPlayer, [
        {
            key: 'seek',
            value: function seek(time) {
                time = Math.max(time, 0);
                if (this.video.duration) {
                    time = Math.min(time, this.video.duration);
                }
                this.video.currentTime = time;
                if (this.danmaku) {
                    this.danmaku.seek();
                }
                this.bar.set('played', time / this.video.duration, 'width');
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.video.pause();
                this.danmaku.pause();
                this.timer.disable('loading');
            }
        },
        {
            key: 'play',
            value: function play() {
                this.video.play();
                this.danmaku.play();
                this.timer.enable('loading');
                this.controller.setAutoHide();
                if (this.options.mutex) {
                    for (var i = 0; i < instances.length; i++) {
                        if (this !== instances[i]) {
                            instances[i].pause();
                        }
                    }
                }
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.video.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                var isSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                this.events.on(name, callback, isSelf);
            }
        },
        {
            key: 'off',
            value: function off(name, callback) {
                this.events.off(name, callback);
            }
        },
        {
            key: 'initMSE',
            value: function initMSE(video, type) {
                var _this2 = this;
                this.type = type;
                switch (this.type) {
                case 'hls':
                case 'm3u8':
                    if (window.Hls) {
                        if (window.Hls.isSupported()) {
                            var options = this.options.pluginOptions.hls;
                            var hls = new window.Hls(options);
                            this.plugins.hls = hls;
                            hls.loadSource(video.src);
                            hls.attachMedia(video);
                            this.events.on('destroy', function () {
                                hls.destroy();
                                delete _this2.plugins.hls;
                            });
                        } else {
                            this.notice('Error: Hls is not supported.');
                        }
                    } else {
                        this.notice('Error: Can\'t find Hls.');
                    }
                    break;
                case 'flv':
                    if (window.flvjs) {
                        if (window.flvjs.isSupported()) {
                            var flvPlayer = window.flvjs.createPlayer(Object.assign(this.options.pluginOptions.flv.mediaDataSource || {}, {
                                type: 'flv',
                                url: video.src
                            }), this.options.pluginOptions.flv.config);
                            this.plugins.flvjs = flvPlayer;
                            flvPlayer.attachMediaElement(video);
                            flvPlayer.load();
                            this.events.on('destroy', function () {
                                flvPlayer.unload();
                                flvPlayer.detachMediaElement();
                                flvPlayer.destroy();
                                delete _this2.plugins.flvjs;
                            });
                        } else {
                            console.log('Error: flvjs is not supported.');
                        }
                    } else {
                        console.log('Error: Can\'t find flvjs.');
                    }
                    break;
                case 'dash':
                case 'mpd':
                    if (window.dashjs) {
                        var dashjsPlayer = window.dashjs.MediaPlayer().create().initialize(video, video.src, false);
                        var _options = this.options.pluginOptions.dash;
                        dashjsPlayer === null || dashjsPlayer === void 0 ? void 0 : dashjsPlayer.updateSettings(_options);
                        this.plugins.dash = dashjsPlayer;
                        this.events.on('destroy', function () {
                            window.dashjs.MediaPlayer().reset();
                            delete _this2.plugins.dash;
                        });
                    } else {
                        this.notice('Error: Can\'t find dashjs.');
                    }
                    break;
                case 'webtorrent':
                    if (window.WebTorrent) {
                        if (window.WebTorrent.WEBRTC_SUPPORT) {
                            this.container.classList.add('dplayer-loading');
                            var _options2 = this.options.pluginOptions.webtorrent;
                            var client = new window.WebTorrent(_options2);
                            this.plugins.webtorrent = client;
                            var torrentId = video.src;
                            video.src = '';
                            video.preload = 'metadata';
                            video.addEventListener('durationchange', function () {
                                return _this2.container.classList.remove('dplayer-loading');
                            }, { once: true });
                            client.add(torrentId, function (torrent) {
                                var file = torrent.files.find(function (file) {
                                    return file.name.endsWith('.mp4');
                                });
                                file.renderTo(_this2.video, {
                                    autoplay: _this2.options.autoplay,
                                    controls: false
                                });
                            });
                            this.events.on('destroy', function () {
                                client.remove(torrentId);
                                client.destroy();
                                delete _this2.plugins.webtorrent;
                            });
                        } else {
                            this.notice('Error: Webtorrent is not supported.');
                        }
                    } else {
                        this.notice('Error: Can\'t find Webtorrent.');
                    }
                    break;
                }
            }
        },
        {
            key: 'initVideo',
            value: function initVideo(video, type) {
                var _this3 = this;
                this.initMSE(video, type);
                console.log(type);
                if (this.options.video.length > 1 && this.options.currentVideo <= this.template.episodeItem.length) {
                    this.template.episodeItem[this.currentVideo].classList.add('focus');
                }
                this.on('loadstart', function () {
                    console.log('loadstart');
                    !_this3.switchingResolution && _this3.container.classList.add('mfunsPlayer-load');
                });
                this.on('error', function () {
                    _this3.container.classList.remove('mfunsPlayer-load');
                    _this3.notice('视频播放失败');
                });
                this.on('loadedmetadata', function () {
                    console.log('loadedmetadata');
                    _this3.container.classList.remove('mfunsPlayer-load');
                    _this3.volume(_this3.options.volume);
                    _this3.video.loop = !!_this3.options.loop || !!_this3.options.listLoop && _this3.options.video.length === 1;
                    getVideoTime(_this3.template);
                    !_this3.switchingResolution && _this3.initResolution();
                    if (_this3.isSwitched) {
                        _this3.events.trigger('switchVideo_end', _this3.video);
                        _this3.play();
                        _this3.isSwitched = false;
                    }
                });
                this.on('progress', function () {
                    var percentage = video.buffered.length ? video.buffered.end(video.buffered.length - 1) / video.duration : 0;
                    _this3.bar.set('loaded', percentage, 'width');
                });
                this.on('play', function () {
                    _this3.playEnd && _this3.danmaku && _this3.danmaku.seek();
                    _this3.playEnd = false;
                    _this3.container.classList.replace('mfunsPlayer-paused', 'mfunsPlayer-playing');
                    _this3.template.player_btn.classList.replace('icon-play', 'icon-pause');
                });
                this.on('pause', function () {
                    console.log('pause');
                    if (_this3.video.paused) {
                        _this3.container.classList.replace('mfunsPlayer-playing', 'mfunsPlayer-paused');
                        _this3.template.player_btn.classList.replace('icon-pause', 'icon-play');
                    }
                });
                this.on('timeupdate', function () {
                    if (!_this3.unableTimeupdate) {
                        _this3.bar.set('played', _this3.video.currentTime / _this3.video.duration, 'width');
                        var ct = parseInt(_this3.video.currentTime);
                        _this3.template.currentTime.innerText = utils.secondToTime(ct);
                        _this3.template.danmakuCurrent.innerText = Object.values(_this3.danmaku.danTunnel).map(function (el) {
                            return Object.values(el).flat();
                        }).flat().length;
                    }
                });
                this.on('ended', function () {
                    _this3.bar.set('played', 1, 'width');
                    _this3.playEnd = true;
                    if (!_this3.video.loop) {
                        if (_this3.listLoop && _this3.currentVideo === _this3.options.video.length - 1) {
                            _this3.switchVideo(0);
                            return;
                        }
                        if (_this3.autoSwitch || _this3.listLoop) {
                            _this3.switchVideo(_this3.currentVideo + 1);
                        }
                    }
                });
                this.on('seeking', function () {
                    _this3.bar.set('played', _this3.video.currentTime / _this3.video.duration, 'width');
                    var ct = parseInt(_this3.video.currentTime);
                    _this3.template.currentTime.innerText = utils.secondToTime(ct);
                });
                var canplay = function canplay() {
                    _this3.container.classList.remove('mfunsPlayer-load');
                };
                this.on('canplay', canplay);
                var _loop = function _loop(i) {
                    video.addEventListener(_this3.events.videoEvents[i], function (e) {
                        _this3.events.trigger(_this3.events.videoEvents[i], e);
                    });
                };
                for (var i = 0; i < this.events.videoEvents.length; i++) {
                    _loop(i);
                }
                this.events.videoEvents.forEach(function (eventName) {
                    if (_this3.events.events[eventName]) {
                        var eventQueue = _this3.events.events[eventName];
                        var newEventQueque = [];
                        eventQueue.forEach(function (event) {
                            newEventQueque.length === 0 && newEventQueque.push(event);
                            !newEventQueque.map(function (ev) {
                                return ev.toString();
                            }).includes(event.toString()) && newEventQueque.push(event);
                        });
                        _this3.events.events[eventName] = newEventQueque;
                    }
                });
            }
        },
        {
            key: 'initResolution',
            value: function initResolution() {
                var _currentVideoOption$r, _currentVideoOption$r2;
                console.log('当前视频分辨率为'.concat(this.video.videoWidth, ' * ').concat(this.video.videoHeight));
                var currentVideoOption = this.options.video[this.currentVideo];
                var resolution = (_currentVideoOption$r = currentVideoOption === null || currentVideoOption === void 0 ? void 0 : (_currentVideoOption$r2 = currentVideoOption.resolution) === null || _currentVideoOption$r2 === void 0 ? void 0 : _currentVideoOption$r2.find(function (el) {
                    return el.url === currentVideoOption.url;
                }).name) !== null && _currentVideoOption$r !== void 0 ? _currentVideoOption$r : utils.getVideoResolution(this.video);
                this.template.resolution.innerHTML = resolution;
                if (!currentVideoOption.resolution) {
                    currentVideoOption.resolution = [{
                            name: resolution,
                            label: utils.resolutionMap.get(resolution),
                            isDefault: true
                        }];
                    this.resolution = currentVideoOption.resolution[0];
                }
                var newResolutionHTML = tplResolution(currentVideoOption);
                this.template.resolutionMask.innerHTML = new DOMParser().parseFromString(newResolutionHTML, 'text/html').body.firstChild.innerHTML;
                this.template.resolutionItem = document.querySelectorAll('.mfunsPlayer-resolution-item');
                this.set.initResolutionSet();
            }
        },
        {
            key: 'switchVideo',
            value: function switchVideo(index) {
                var _currentVideo$pic;
                this.pause();
                var total = this.options.video.length - 1;
                if (index > total || index < 0 || index === this.currentVideo)
                    return;
                this.handleSwitchVideo(index);
                this.bar.set('loaded', 0, 'width');
                this.bar.set('played', 0, 'width');
                this.isSwitched = true;
                this.danmakuLoaded = false;
                this.videoLoaded = false;
                var currentVideo = this.options.video[index];
                this.danmaku && this.danmaku.reload(currentVideo.danId, currentVideo.advDanId ? {
                    id: currentVideo.advDanId,
                    address: this.options.advancedDanmaku.api,
                    token: this.options.advancedDanmaku.token
                } : null, currentVideo.danmakuAddition, currentVideo.otherDanParams);
                this.controller.thumbnails && this.controller.thumbnails.reload(currentVideo.thumbnails);
                this.video.poster = (_currentVideo$pic = currentVideo.pic) !== null && _currentVideo$pic !== void 0 ? _currentVideo$pic : '';
                this.video.src = currentVideo.url;
                this.initMSE(this.video, currentVideo.type || 'auto', true);
                this.template.headTitle.innerText = ''.concat(currentVideo.title);
                this.events.trigger('switchVideo_start', index);
            }
        },
        {
            key: 'handleSwitchVideo',
            value: function handleSwitchVideo(index) {
                console.log(index);
                resetVideoTime(this.template);
                var total = this.template.episodeItem.length - 1;
                this.currentVideo = index;
                if (index > total)
                    return;
                if (index === total) {
                    this.template.controllerLeft.classList.add('noSkip');
                } else {
                    this.template.controllerLeft.classList.remove('noSkip');
                }
                _toConsumableArray(this.template.episodeItem).forEach(function (element, i) {
                    element.classList.remove('focus');
                });
                this.template.episodeItem[index].classList.add('focus');
            }
        },
        {
            key: 'switchResolution',
            value: function switchResolution(resolution) {
                var _this4 = this;
                var showNotice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                var name = resolution.name, url = resolution.url, type = resolution.type;
                var allResolution = this.options.video[this.currentVideo].resolution;
                var resolutionIndex = allResolution.map(function (r) {
                    return r.url;
                }).indexOf(url);
                console.log(resolutionIndex, name);
                _toConsumableArray(this.template.resolutionItem).forEach(function (el) {
                    return el.classList.remove('focus');
                });
                this.template.resolutionItem[resolutionIndex].classList.add('focus');
                if (this.resolution.name === resolution.name || this.switchingResolution || !allResolution) {
                    return;
                } else {
                    this.prevResolution = this.resolution;
                    this.resolution = resolution;
                }
                this.switchingResolution = true;
                this.prevVideo = this.video;
                this.prevEvents = this.events.events;
                var videoHTML = tplVideo({
                    current: false,
                    pic: null,
                    preload: 'auto',
                    url: url
                });
                var videoEle = new DOMParser().parseFromString(videoHTML, 'text/html').body.firstChild;
                videoEle.style.width = this.video.style.width;
                videoEle.style.height = this.video.style.height;
                videoEle.style.objectFit = this.video.style.objectFit;
                videoEle.style.filter = this.video.style.filter;
                videoEle.style.transform = this.video.style.transform;
                videoEle.loop = this.video.loop;
                this.template.videoMask.insertBefore(videoEle, this.video);
                this.initVideo(videoEle, type || this.options.video[this.currentVideo].type, true);
                showNotice && this.notice('切换中', 0, undefined, 'switch-resolution');
                this.events.trigger('resolution_start', this.resolution.name);
                var loadedmetadata = function loadedmetadata() {
                    if (_this4.prevVideo) {
                        videoEle.currentTime = _this4.prevVideo.currentTime;
                        var canplay = function canplay() {
                            if (_this4.prevVideo) {
                                var _paused = _this4.prevVideo.paused;
                                _this4.template.resolution.innerHTML = name;
                                _this4.prevVideo.style.display = 'none';
                                _this4.prevVideo.pause();
                                _this4.template.videoMask.removeChild(_this4.prevVideo);
                                _this4.prevVideo = null;
                                _this4.video = videoEle;
                                _this4.video.classList.add('mfunsPlayer-video-current');
                                !_paused && _this4.play();
                                showNotice && _this4.notice('已切换至 '.concat(_this4.resolution.name), undefined, undefined, 'switch-resolution');
                                console.log('当前视频分辨率为'.concat(_this4.video.videoWidth, ' * ').concat(_this4.video.videoHeight));
                                _this4.switchingResolution = false;
                                videoEle.removeEventListener('canplay', canplay);
                                videoEle.removeEventListener('loadedmetadata', loadedmetadata);
                                _this4.events.trigger('resolution_end');
                            }
                        };
                        _this4.video.currentTime = _this4.prevVideo.currentTime;
                        videoEle.addEventListener('canplay', canplay);
                    }
                };
                videoEle.addEventListener('loadedmetadata', loadedmetadata);
                videoEle.addEventListener('error', function () {
                    if (!_this4.video.error) {
                        return;
                    }
                    if (_this4.prevVideo) {
                        _this4.template.videoWrap.removeChild(_this4.video);
                        _this4.resolution = _this4.prevResolution;
                        _this4.events.events = _this4.prevEvents;
                        _this4.template.resolution.innerHTML = _this4.prevResolution.name;
                        if (!paused) {
                            _this4.play();
                        }
                        showNotice && _this4.notice('切换失败');
                        _this4.prevVideo = null;
                        _this4.switchingResolution = false;
                    }
                });
            }
        },
        {
            key: 'volume',
            value: function volume(percentage) {
                if (!isNaN(percentage)) {
                    percentage = Math.min(Math.max(percentage, 0), 1).toFixed(2);
                    this.video.volume = percentage;
                    this.video.muted = false;
                    this.options.mode === 'web' && this.events.trigger('volume_change', percentage);
                }
                return this.video.volume;
            }
        },
        {
            key: 'brigntness',
            value: function brigntness(percentage) {
                if (!isNaN(percentage)) {
                    percentage = Math.min(Math.max(percentage, 0), 1).toFixed(2);
                    this.events.trigger('brightness_change', percentage);
                }
            }
        },
        {
            key: 'setPlayMode',
            value: function setPlayMode() {
                var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var allOptions = _toConsumableArray(this.template.playMode.querySelectorAll('.mfunsPlayer-player-set-option'));
                var loop = args.loop, listLoop = args.listLoop, autoSwitch = args.autoSwitch;
                this.video.loop = !!loop || !!listLoop && this.options.video.length === 1;
                this.listLoop = !!listLoop;
                this.autoSwitch = !!autoSwitch;
                allOptions.forEach(function (ele) {
                    return ele.classList.remove('focus');
                });
                if (loop) {
                    allOptions[1].classList.add('focus');
                    return;
                } else if (listLoop) {
                    allOptions[2].classList.add('focus');
                    return;
                } else if (autoSwitch) {
                    allOptions[3].classList.add('focus');
                } else {
                    allOptions[0].classList.add('focus');
                }
            }
        },
        {
            key: 'sendDanmaku',
            value: function sendDanmaku(dan) {
                if (typeof dan === 'string') {
                    this.danmaku.send({ text: dan });
                } else {
                    this.danmaku.send(dan);
                }
            }
        },
        {
            key: 'shieldDanmaku',
            value: function shieldDanmaku(type, flag) {
                this.danmaku.shield(type, flag);
            }
        },
        {
            key: 'speed',
            value: function speed(rate) {
                this.video.playbackRate = rate;
                return this.video.playbackRate;
            }
        },
        {
            key: 'resize',
            value: function resize() {
                this.danmaku && this.danmaku.resize();
                this.advancedDanmaku && this.advancedDanmaku.resize();
                if (this.controller.thumbnails) {
                    this.controller.thumbnails.resize(160, this.video.videoHeight / this.video.videoWidth * 160, this.template.barWrap.offsetWidth);
                }
                window.removeEventListener('resize', this.rescale);
                if (this.set.videoScale) {
                    this.video.style['object-fit'] = 'fill';
                    this.rescale();
                    window.addEventListener('resize', this.rescale);
                } else {
                    this.video.style['object-fit'] = '';
                    this.video.style.maxHeight = '100%';
                    this.video.style.width = '';
                    this.video.style.height = '';
                }
                this.events.trigger('resize');
            }
        },
        {
            key: 'rescale',
            value: function rescale() {
                var hscale = this.template.videoMask.clientWidth * this.set.videoScale[1];
                var wscale = this.template.videoMask.clientHeight * this.set.videoScale[0];
                this.video.style.maxHeight = '100%';
                if (wscale > hscale && this.set.videoScale[1] !== 0) {
                    this.video.style.width = '100%';
                    this.video.style.height = ''.concat(hscale / wscale * 100, '%');
                    return;
                } else if (this.set.videoScale[1] === this.set.videoScale[0]) {
                    this.video.style.width = '100%';
                    this.video.style.height = '100%';
                    return;
                } else if (this.set.videoScale[0] === 1 && this.set.videoScale[1] === 0) {
                    console.log('填充');
                    this.video.style['object-fit'] = '';
                    this.video.style.width = '100%';
                    this.video.style.maxHeight = 'none';
                    this.video.style.height = '';
                    return;
                } else {
                    this.video.style.height = '100%';
                    this.video.style.width = ''.concat(wscale / hscale * 100, '%');
                }
            }
        },
        {
            key: 'notice',
            value: function notice(text) {
                var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
                var opacity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.8;
                var id = arguments.length > 3 ? arguments[3] : undefined;
                var oldNoticeEle;
                if (id) {
                    oldNoticeEle = document.getElementById('mfunsPlayer-notice-'.concat(id));
                    if (oldNoticeEle) {
                        oldNoticeEle.innerHTML = text;
                    }
                    if (this.noticeList[id]) {
                        clearTimeout(this.noticeList[id]);
                        this.noticeList[id] = null;
                    }
                }
                if (!oldNoticeEle) {
                    var notice = Template.NewNotice(text, opacity, id);
                    this.template.noticeList.appendChild(notice);
                    oldNoticeEle = notice;
                }
                this.events.trigger('notice_show', oldNoticeEle);
                if (time > 0) {
                    this.noticeList[id] = setTimeout(function (e, mp) {
                        return function () {
                            e.addEventListener('animationend', function () {
                                mp.template.noticeList.removeChild(e);
                            });
                            e.classList.add('remove-notice');
                            mp.events.trigger('notice_hide');
                            mp.noticeList[id] = null;
                        };
                    }(oldNoticeEle, this), time);
                }
            }
        },
        {
            key: 'tip',
            value: function tip(type, val) {
                if (isNaN(val)) {
                    console.warn('invalid value:', val);
                    return;
                }
                if (type === 'volume') {
                    this.template.volumeTip.classList.remove('hidden');
                    var loadedBar = this.template.volumeTip.querySelector('.loaded-bar');
                    var icon = this.template.volumeTip.querySelector('.tip-icon');
                    if (val <= 0) {
                        icon.classList.replace('icon-volume', 'icon-volume-off');
                    } else {
                        icon.classList.replace('icon-volume-off', 'icon-volume');
                    }
                    loadedBar.style.width = val * 100 + '%';
                } else if (type === 'brightness') {
                    this.template.brightnessTip.classList.remove('hidden');
                    var _loadedBar = this.template.brightnessTip.querySelector('.loaded-bar');
                    _loadedBar.style.width = val * 100 + '%';
                }
                this.events.trigger('tip_show');
            }
        },
        {
            key: 'initDeviceStatus',
            value: function initDeviceStatus() {
                var _this5 = this;
                if (window.navigator.getBattery) {
                    var batteryQuantity = this.template.batteryStatus.querySelector('.battery-quantity-value');
                    var watchBattery = function watchBattery() {
                        batteryQuantity.style.width = _this5.battery.level * 100 + '%';
                        if (_this5.battery.charging) {
                            _this5.template.batteryStatus.classList.add('charging');
                            _this5.template.batteryStatus.classList.remove('warn');
                        } else {
                            _this5.template.batteryStatus.classList.remove('charging');
                            if (_this5.battery.level <= 0.2) {
                                _this5.template.batteryStatus.classList.add('warn');
                            } else {
                                _this5.template.batteryStatus.classList.remove('warn');
                            }
                        }
                    };
                    window.navigator.getBattery().then(function (battery) {
                        _this5.battery = battery;
                        watchBattery();
                        _this5.battery.addEventListener('chargingchange', function () {
                            watchBattery();
                        });
                        _this5.battery.addEventListener('levelchange', function () {
                            console.log('当前设备电量', _this5.battery.level);
                            if (!battery.charging) {
                                batteryQuantity.style.width = _this5.battery.level * 100 + '%';
                                if (_this5.battery.level <= 0.2) {
                                    _this5.template.batteryStatus.classList.add('warn');
                                } else {
                                    _this5.template.batteryStatus.classList.remove('warn');
                                }
                            }
                        });
                    });
                }
                var watchNetwork = function watchNetwork() {
                    var _window$navigator$con;
                    var networkType = (_window$navigator$con = window.navigator.connection.type) !== null && _window$navigator$con !== void 0 ? _window$navigator$con : '';
                    if (networkType === 'cellular') {
                        _this5.notice('正在使用移动数据\uFF0C请注意流量消耗');
                        if (_this5.template.networkStatus.classList.contains('wifi')) {
                            _this5.template.networkStatus.classList.replace('wifi', 'cellular');
                        } else {
                            _this5.template.networkStatus.classList.add('cellular');
                        }
                    }
                    if (networkType === 'wifi') {
                        if (_this5.template.networkStatus.classList.contains('cellular')) {
                            _this5.template.networkStatus.classList.replace('cellular', 'wifi');
                        } else {
                            _this5.template.networkStatus.classList.add('wifi');
                        }
                    }
                    if (window.navigator.onLine) {
                        console.log('online');
                        _this5.template.networkStatus.classList.remove('offline');
                    } else {
                        _this5.template.networkStatus.classList.remove('wifi');
                        _this5.template.networkStatus.classList.remove('cellular');
                        _this5.template.networkStatus.classList.add('offline');
                    }
                    console.log(window.navigator.connection);
                };
                if (window.navigator.connection) {
                    window.navigator.connection.addEventListener('change', utils.debounce(watchNetwork, 50));
                    watchNetwork();
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                instances.splice(instances.indexOf(this), 1);
                this.pause();
                this.controller.destroy();
                this.timer.destroy();
                this.video.src = '';
                this.container.innerHTML = '';
                clearInterval(this.clock);
                this.events.trigger('destroy');
            }
        }
    ]);
    return mfunsPlayer;
}();
export {
    mfunsPlayer as default
};